/* Summr: little add-to-cart animation. The product image shrinks and flies into the cart icon,
   the cart icon bumps, and the cart drawer glides open (slowly) while the product is landing. */
(function () {
  if (window.__summrAtc) return;
  window.__summrAtc = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !Element.prototype.animate) return;

  var DRAWER_MS = 650;
  var FLY_MS = 700;

  function visible(el) {
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function cartIcon() {
    var list = document.querySelectorAll('cart-icon, .header-actions__cart-icon, header a[href$="/cart"], header [aria-controls*="cart"]');
    for (var i = 0; i < list.length; i++) {
      if (visible(list[i])) return list[i];
    }
    return null;
  }

  function sourceImage(btn) {
    var card = btn.closest('product-card, .product-card');
    var imgs = card
      ? card.querySelectorAll('img')
      : document.querySelectorAll('media-gallery .product-media-container img');
    for (var i = 0; i < imgs.length; i++) {
      if (visible(imgs[i]) && imgs[i].getBoundingClientRect().bottom > 0) return imgs[i];
    }
    return null;
  }

  function openDrawer() {
    var d = document.querySelector('cart-drawer-component');
    if (!d || typeof d.open !== 'function') return;
    try { d.open(); } catch (e) { return; }
    var dlg = d.querySelector('dialog');
    if (!dlg) return;
    var ease = 'cubic-bezier(.22,.8,.3,1)';
    dlg.animate(
      [{ transform: 'translateX(100%)' }, { transform: 'translateX(0)' }],
      { duration: DRAWER_MS, easing: ease }
    );
    try {
      dlg.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: DRAWER_MS,
        easing: 'ease-out',
        pseudoElement: '::backdrop'
      });
    } catch (e) {}
  }

  function fly(img, icon) {
    var from = img.getBoundingClientRect();
    var to = icon.getBoundingClientRect();
    var size = Math.min(from.width, from.height, 260);
    var ghost = document.createElement('img');
    ghost.src = img.currentSrc || img.src;
    ghost.alt = '';
    ghost.setAttribute('aria-hidden', 'true');
    ghost.style.cssText =
      'position:fixed;z-index:99999;pointer-events:none;object-fit:cover;border-radius:6px;' +
      'box-shadow:0 10px 30px rgba(0,0,0,.35);left:' + (from.left + from.width / 2 - size / 2) + 'px;top:' +
      (from.top + from.height / 2 - size / 2) + 'px;width:' + size + 'px;height:' + size + 'px;';
    document.body.appendChild(ghost);
    var dx = to.left + to.width / 2 - (from.left + from.width / 2);
    var dy = to.top + to.height / 2 - (from.top + from.height / 2);
    var anim = ghost.animate(
      [
        { transform: 'translate(0,0) scale(1)', opacity: 1 },
        { transform: 'translate(' + dx * 0.55 + 'px,' + (dy * 0.55 - 30) + 'px) scale(0.55)', opacity: 0.95, offset: 0.5 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(0.08)', opacity: 0.2 }
      ],
      { duration: FLY_MS, easing: 'cubic-bezier(.5,0,.2,1)' }
    );
    anim.onfinish = function () {
      ghost.remove();
      icon.animate(
        [
          { transform: 'scale(1)' },
          { transform: 'scale(1.35)' },
          { transform: 'scale(0.92)' },
          { transform: 'scale(1)' }
        ],
        { duration: 420, easing: 'ease-out' }
      );
    };
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('add-to-cart-component button, button[name="add"]');
      if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      btn.animate(
        [{ transform: 'scale(1)' }, { transform: 'scale(0.97)' }, { transform: 'scale(1)' }],
        { duration: 260, easing: 'ease-out' }
      );
      var img = sourceImage(btn);
      var icon = cartIcon();
      if (img && icon) fly(img, icon);
      setTimeout(openDrawer, img && icon ? 150 : 0);
    },
    true
  );
})();
